module.exports = __webpack_public_path__ + "static/media/video.21948192.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.webm
// module id = 312
// module chunks = 0